import { lighten } from "@mui/material"
import Box from "@mui/material/Box"
import { TColors } from "@cakemail-org/ui-components-v2"

export function ColorIcon({ size, color }: { color?: TColors | string, size?: number }) {
    return <Box className="colorIcon" sx={(theme) => {
        let appliedColor = theme.palette.primary.main

        if (color) {
            if (color[0] === "#") {
                appliedColor = color
            } else {
                appliedColor = theme.palette[color as TColors].main
            }
        }

        return {
            width: size || 12,
            height: size || 12,
            marginRight: 3,
            backgroundColor: appliedColor,
            borderRadius: 1
        }
    }}>
    </Box>
}